import React from "react";
import ImageView from "../snippet/ImageView";

const LoadingScreenView = () =>
{

    return <section className="h-100 content-block set-bg-white fixed-top">
        <div className="h-100 position-relative">
            <div className="absolute-middle w-100">
                <div className="container">

                    <div className="row">

                        <div className="col-12 text-center">
                            <ImageView
                                url="/img/logo/png-logo/logo-black.png?v=1"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
};

export default LoadingScreenView;